var promotion = "https://shopfront-cdn.tekoapis.com/static/251a15c03b923c4b.svg";

export { promotion as default };
